import { Component, ElementRef, EventEmitter, HostListener, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'dynamic-date-input',
    templateUrl: 'dynamic-date-input.component.html'
})

export class DynamicDateInputComponent implements OnInit {

    @Input() readonly: boolean;
    @Input() disabled: boolean;

    @Input() value: string;
    @Input() text: string;

    @Input() isFocus: boolean;
    @Input() placeholder: string;

    @Input() showClear: boolean;


    @Output() inputClick = new EventEmitter();
    @Output() tabKeydown =  new EventEmitter();
    @Output() clear =  new EventEmitter();

    @ViewChild('clearIcon') clearIcon: ElementRef;
    
    constructor(private inject: Injector) { }

    ngOnInit() { }

    @HostListener('mouseenter', ['$event'])
    onMouseEnter(event) {
        if (this.value && !this.disabled && !this.readonly) {
            if (this.value && this.clearIcon) {
                this.clearIcon.nativeElement.style.visibility = '';
            }
        }
    }

    @HostListener('mouseleave', ['$event'])
    onMouseLeave(event) {
        if (!this.disabled && this.clearIcon && !this.readonly) {
            this.clearIcon.nativeElement.style.visibility = 'hidden';
        }
    }
}